import checkout from '@lib/analytics/emarsys/checkout'
import confirmation from '@lib/analytics/emarsys/confirmation'
import results from '@lib/analytics/emarsys/results'
import search from '@lib/analytics/emarsys/search'

const emarsysScriptTemplate = (merchantId: string) => `
  var ScarabQueue = ScarabQueue || [];
  (function(id) {
    if (document.getElementById(id)) return;
    var js = document.createElement('script'); js.id = id;
    js.src = 'https://cdn.scarabresearch.com/js/${merchantId}/scarab-v2.js';
    var fs = document.getElementsByTagName('script')[0];
    fs.parentNode.insertBefore(js, fs);
  })('scarab-js-api');
`

const init = ({ enabled, merchant_id }: Analytics.Settings['emarsys']) => {
  if (!enabled || !merchant_id) return

  const emarsys = document.createElement('script')
  emarsys.innerHTML = emarsysScriptTemplate(merchant_id)
  document.head.appendChild(emarsys)
}

export default {
  init,
  search,
  results,
  checkout,
  confirmation,
}
